export enum CodeValueGroups {
    CommissionRole = "commission.CodeCommissionRole",
    CommissionTransactionStatus = "commission.CodeCommissionTransactionStatus",
    ARStatus = "trn.CodeARStatus",
    BillingTransactionStatus = "trn.CodeBillingTransactionStatus"
}

export enum TransactionType {
    PermanentPlacement = "PermanentPlacement"
}

export enum CommissionAdjustmentHeaderType {
    Draws = "Draws"
}

export type PayoutType = 'scheduled' | 'adhoc';